import { handleActions } from 'redux-actions';

import {
  setPaginatedCustomersData,
  fetchPaginatedCustomersSuccess,
  setPaginatedCustomersLoading,
} from '~/actions/paginatedCustomers';

export const paginatedCustomers = handleActions(
  {
    [setPaginatedCustomersData]: (state, { payload: { newCustomers } }) => {
      const customers = [...state.customers];

      newCustomers.forEach((newCustomer) => {
        const customerIndex = customers.findIndex(
          (customer) => customer._id === newCustomer.id
        );

        if (customerIndex === -1) return;

        customers[customerIndex] = {
          ...customers[customerIndex],
          ...newCustomer,
        };
      });

      return {
        ...state,
        customers: [...customers],
      };
    },
    [fetchPaginatedCustomersSuccess]: (
      state,
      { payload: { customers, total, offset, limit, filters } }
    ) => ({
      ...state,
      customers,
      total,
      offset,
      limit,
      filters,
      isLoading: false,
    }),
    [setPaginatedCustomersLoading]: (state, { payload: isLoading }) => ({
      ...state,
      isLoading,
    }),
  },
  {
    isLoading: true,
    customers: [],
    total: 0,
    offset: 0,
    limit: 1,
    filters: null,
  }
);
